export default _theme => ({
  helperTextAndChipsListContainer: {
    height: '100%',
  },
  chipsContainer: {
    marginTop: '5px',
    marginBottom: '8px',
  },
})
